import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetTemplateItemDocument,
  TemplateItemDataFragment,
} from '../../types/api/graphql';

export function useTemplateItem(id: string | null | undefined) {
  const { data: templateItemData, loading: templateItemLoading } =
    useCacheQuery(GetTemplateItemDocument, {
      variables: {
        id: id ?? '',
      },
      skip: !id,
    });

  const data = useMemo(
    () =>
      templateItemData?.template
        ? (templateItemData?.template as TemplateItemDataFragment)
        : null,
    [templateItemData?.template]
  );

  return {
    data,
    loading: templateItemLoading,
  };
}
